module.exports = __webpack_public_path__ + "img/start-pois-tour.0633644e.svg";